import { render, staticRenderFns } from "./CompanyDepartmentAdd.vue?vue&type=template&id=952103b2&"
import script from "./CompanyDepartmentAdd.vue?vue&type=script&lang=js&"
export * from "./CompanyDepartmentAdd.vue?vue&type=script&lang=js&"
import style0 from "./CompanyDepartmentAdd.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports